<template>
    <div class="list-config-layout">
        <el-button class="list-config-save" type="info" icon="el-icon-folder-checked" @click="saveData" :loading="submitLoad">保存</el-button>
        <el-transfer
                v-loading="tableLoading"
                filterable
                :filter-method="filterMethod"
                :data="data"
                v-model="value"
                :target-order="'push'"
                :titles="['未显示字段', '已显示字段']"
                :props="{ key: 'fieldModelId', label: 'fieldName' }"
        />
    </div>
</template>
<script>
    import Sortable from 'sortablejs'
    export default {
        name: 'listConfig',
        props: ['meta'],
        data () {
            return {
                tableLoading: false,
                submitLoad: false,
                data: [],
                value: []
            }
        },
        mounted () {
            let el = document
                .querySelector('.el-transfer')
                .querySelectorAll('.el-checkbox-group')[1]
            new Sortable(el, {
                forceFallback: false,
                onUpdate: event => {
                    let box = this.$el
                        .querySelector('.el-transfer')
                        .querySelectorAll('.el-checkbox-group')[1]
                    let nums = this.$el
                        .querySelector('.el-transfer')
                        .querySelectorAll('.el-checkbox-group')[1].childNodes.length
                    if (event.newIndex >= nums) {
                        return
                    }
                    let newIndex = event.newIndex
                    let oldIndex = event.oldIndex
                    let $label = box.children[newIndex]
                    let $oldLabel = box.children[oldIndex]
                    box.removeChild($label)
                    if (newIndex < oldIndex) {
                        box.insertBefore($label, $oldLabel)
                    } else {
                        box.insertBefore($label, $oldLabel.nextSibling)
                    }
                    let item = this.value.splice(oldIndex, 1)
                    this.value.splice(newIndex, 0, item[0])
                }
            })
        },
        created () {
            this.load()
        },
        methods: {
            filterMethod (query, item) {
                let regStr = query.replace(/\*/g, '.*')
                let reg = new RegExp(regStr)
                return reg.test(item.fieldName)
            },
            async saveData () {
                if (this.submitLoad) return
                this.submitLoad = true
                let method = 'put'
                let url = `/api/fieldModels/${this.meta.ledgerId}/batchAddFieldsOfPageData`
                await this.$http[method](url, this.value.map((fieldModelId, fieldOrderNoPageData) => {
                    return { fieldModelId, fieldOrderNoPageData }
                })).finally(() => {
                    this.submitLoad = false
                })
                this.$message.success('保存成功')
                this.load()
            },
            async load () {
                this.tableLoading = true
                const { data } = await this.$http.get(`/api/fieldModels/${this.meta.ledgerId}/listFieldsOfPageData`).finally(() => {
                    this.tableLoading = false
                })
                const resData = data.data || {}
                this.data = [ ...(resData.listWaitSelected || []), ...(resData.listSelected || []) ]
                this.value = (resData.listSelected || []).map(item => item.fieldModelId)
            }
        }
    }
</script>

<style lang="scss">
    .list-config-layout {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        height: 100%;
        .list-config-save {
            margin-bottom: 10px;
        }
        .el-transfer {
            flex: 1;
            min-height: 400px;
        }
        .el-transfer-panel{
            height: 100%;
            width: 400px;
        }
        .el-transfer-panel__body {
            height: calc(100% - 40px);
        }
        .el-transfer-panel__list.is-filterable{
            height: calc(100% - 62px);
        }
        .el-transfer__buttons {
            button {
                display: block;
                margin: 0;
                &:first-child {
                    margin-bottom: 12px;
                }
            }
        }
    }
</style>
